import { lazy } from 'react';
import { CustomersList } from './components/CustomersList';
import { useTranslation } from 'react-i18next';
import { useHistory, Switch, Route, useRouteMatch } from 'react-router-dom';
import { Header } from '../../components/common/Header';
import { PayAuthorizations } from '../authorizations/PayAuthorizations';
import { PayAccessControl } from '../authorizations/PayAccessControl';
import ImportCustomersScreen from './ImportCustomersScreen';

const CustomerDebtInvoiceScreen = lazy(() =>
  import('../debtInvoice/CustomerDebtInvoiceScreen').then((m) => ({
    default: m.CustomerDebtInvoiceScreen,
  }))
);
const CustomerDetailScreen = lazy(() =>
  import('./CustomerDetailScreen').then((m) => ({
    default: m.CustomerDetailScreen,
  }))
);
const NewCustomerScreen = lazy(() =>
  import('./NewCustomerScreen').then((m) => ({ default: m.NewCustomerScreen }))
);
const EditCustomerScreen = lazy(() =>
  import('./EditCustomerScreen').then((m) => ({
    default: m.EditCustomerScreen,
  }))
);

export function CustomersScreen(): JSX.Element {
  const { t } = useTranslation();
  const history = useHistory();

  const handleNewClick = () => {
    history.push('/customers/new');
  };

  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <Header
          title={t('screens.customers.title')}
          primaryButton={{
            text: t('common.new_customer'),
            onClick: handleNewClick,
            allowedAuthorization: PayAuthorizations.createEditCustomer,
          }}
        />
        <CustomersList />
      </Route>
      <Route exact path={`${path}/:customer_id/new-debt-invoice`}>
        <PayAccessControl allowed={PayAuthorizations.createInvoice}>
          <CustomerDebtInvoiceScreen />
        </PayAccessControl>
      </Route>
      <Route exact path={`${path}/:customer_id/detail`}>
        <CustomerDetailScreen />
      </Route>
      <Route exact path={`${path}/new`}>
        <PayAccessControl allowed={PayAuthorizations.createEditCustomer}>
          <NewCustomerScreen />
        </PayAccessControl>
      </Route>
      <Route exact path={`${path}/:customer_id/edit`}>
        <PayAccessControl allowed={PayAuthorizations.createEditCustomer}>
          <EditCustomerScreen />
        </PayAccessControl>
      </Route>
      <Route exact path={`${path}/import`}>
        <PayAccessControl allowed={PayAuthorizations.createBulkCustomers}>
          <ImportCustomersScreen />
        </PayAccessControl>
      </Route>
    </Switch>
  );
}
